import { faCirclePlus, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, FileButton, Group, Modal, MultiSelect, NumberInput } from '@mantine/core';
import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { createB2BAPI } from '../../api/Interceptor';
import B2BInput from '../../components/common/B2BInput';
import B2BModal from '../../components/common/B2BModal';
import B2BSelect from '../../components/common/B2BSelect';
import notify from '../../utils/Notification';
import { ProductContext } from '../../Context/ProductContext';
import './ProductType.css';
import { Carousel } from '@mantine/carousel';
import { IconPercentage, IconUpload } from '@tabler/icons-react';
import { useMediaQuery, useDebouncedValue } from '@mantine/hooks';
import { useNavigate } from 'react-router-dom';


const divStyle = { display: 'flex', alignItems: 'center', gap: '0.5rem' }
const ProductType = ({ isReadOnly = false, isCondition, tabInfo }) => {
    const [fCCValue, setFCCValue] = useState('');
    const [fabricValue, setFabricValue] = useState([]);
    const isMobile = useMediaQuery("(max-width: 767px)");
    const initialData = {
        name: "",
        status: "ACTIVE",
        fromDate: "",
        toDate: "",
        seasonCode: ""

    }
    const ctx = useContext(ProductContext);
    if (!ctx) {
        console.error("⚠️ ProductContext not found! Make sure your component is wrapped in <ProductContext.Provider>.");
        return null;
    }
    const { product, handleChange, addProduct, setProduct, imageFile, setImageFile, inputError, setInputError, setHasMultiSelectCategoryMandatory, validateProduct } = ctx;
    const [brand, setBrand] = useState([]);
    const [productTags, setProductTags] = useState([]);
    const [taxonomy, setTaxonomy] = useState([]);
    const [modalContent, setModalContent] = useState(initialData);
    const [activeComponent, setActiveComponent] = useState('');
    const [contentUpdated, setContentUpdated] = useState(false)
    const [season, setSeason] = useState([]);
    const [activeSwatch, setActiveSwatch] = useState(null);
    const [swatchNotifyData, setSwatchNotifyData] = useState({
        awbNumber: '',
        docNumber: '',
        courierName: '',
        swatchQuantity: '',
        dispatchDate: '',
        deliveryDate: '',
    });


    const [openSeason, setOpenSeason] = useState(false);
    const [selectedUOM, setSelectedUOM] = useState("Kg");
    const [mappedRib, setMappedRib] = useState([]);
    const [lastChild, setLastChild] = useState([]);
    const navigate = useNavigate();
    const [attributes, setAttributes] = useState({});
    const [selectedPairs, setSelectedPairs] = useState([{ key: '', values: [] }]);
    const [combinations, setCombinations] = useState([]);
    const [variants, setVariants] = useState([]);
    const [activeTab, setActiveTab] = useState('Transaction');
    const [productVariantMap, setProductVariantMap] = useState(new Map())
    const [existingPairs, setExistingPairs] = useState([]);
    const [existingPairsKeys, setExistingPairsKeys] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm] = useDebouncedValue(searchTerm, 500);
    const [imageFiles, setImageFiles] = useState([]); // multiple files
    const [imageError, setImageError] = useState(null);
    const [fabricContent, setFabricContent] = useState({});
    const [categorys, setCategorys] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [open, setOpen] = useState([]);
    const openRef = useRef(null);
    const isRowExpanded = (index) => expandedRows.includes(index);
    const [totalPercent, setTotalpercent] = useState(product?.totalProductPercent || 0);
    const [selectedPairsFabric, setSelectedPairsFabric] = useState([{ key: '', values: [], value: null }]);

    const B2B_API = createB2BAPI();
    const resetRef = useRef(null);


    useEffect(() => {
        fetchAllBrand();
        fetchAllTags();
        getAllTaxonomy();
        getAllSeason();
    }, [contentUpdated]);
    const getAvailableKeysFabric = (currentIndex) => {
        const selectedKeys = selectedPairsFabric.map(pair => pair.key);
        return Object.keys(keyToNameMap).filter(key => !selectedKeys.includes(key) || selectedPairsFabric[currentIndex].key === key);
    };
    const fabricContentCode = async (newPairs) => {
        try {
            const results = await Promise.all(
                Object.entries(newPairs).map(async ([key, value]) => {
                    const res = await B2B_API.get(`product-category/category/${key}`).json();
                    const name = res.response.name;
                    const fcc = name.substring(0, 3).toUpperCase();
                    return `${fcc}-${value}%`;
                })
            );
            const formattedFCC = results.join(' ');
            setProduct(prevState => ({
                ...prevState,
                fabricContent: {
                    ...prevState.fabricContent,
                    value: formattedFCC,
                },
            }));
            setFCCValue(formattedFCC);
        } catch (error) {
            console.error('Error fetching category data: ', error);
        }
    };
    const jsonswatch = [
        {
            label: 'USSID',
            value: product.vendorProductInfo?.ussId || product?.ussId || '',
            onChange: (event) => handleChange(event, 'vendorProductInfo.ussId', 'ussIdErrorMessage'),
            type: "text",
            fieldType: 'textField',
            require: true,
            disabled: true,
            placeholder: "  ",
            error: inputError?.ussIdError || '',
        },

        {
            fieldType: "checkbox",
            label: "Swatch Received",
            value: product?.swatchReceived ?? false,
            type: "checkbox",
            disabled: true,
            error: inputError?.swatchReceivedError,
        },
        {
            fieldType: "checkbox",
            label: "Swatch Sent",
            value: product?.swatchSent ?? false,
            onChange: () => {
                if (!product?.swatchSent) {
                    setActiveSwatch("sent");
                }
            },
            type: "checkbox",
            disabled: product?.swatchSent === true,
            error: inputError?.swatchSentError,
        },
    ];
    const handleSwatchSample = async () => {
        if (!activeSwatch) return;

        if (activeSwatch === "sent") {
            if (
                !swatchNotifyData.awbNumber?.trim() ||
                !swatchNotifyData.docNumber?.trim() ||
                !swatchNotifyData.courierName?.trim() ||
                !swatchNotifyData.swatchQuantity ||
                !swatchNotifyData.dispatchDate ||
                !swatchNotifyData.deliveryDate
            ) {
                notify({
                    error: true,
                    success: false,
                    title: "All fields are mandatory",
                });
                return;
            }

            const dispatch = new Date(swatchNotifyData.dispatchDate);
            const delivery = new Date(swatchNotifyData.deliveryDate);

            if (delivery < dispatch) {
                notify({
                    error: true,
                    success: false,
                    title: "Delivery Date should be after the Dispatch Date",
                });
                return;
            }
        }

        try {
            showLoader();
            let url = "";
            let successTitle = "";

            if (activeSwatch === "sent") {
                url = `draftProduct/updateSwatchSent?id=${product?.draftProductId}`;
                successTitle = "Swatch Sent successfully";

                const payload = {
                    draftProductId: product?.draftProductId,
                    ...swatchNotifyData,
                    swatchSent: true,
                    saveGe: false,
                };

                await B2B_API.post(`swatchNotifyData/create`, {
                    json: payload,
                }).json();
            } else if (activeSwatch === "received") {
                url = `draftProduct/updateSwatchReceived?id=${product?.draftProductId}`;
                successTitle = "Swatch marked as Received successfully";
            }

            if (url) {
                await B2B_API.get(url);
                setProduct((prev) => ({
                    ...prev,
                    vendorProductInfo: {
                        ...prev.vendorProductInfo,
                        swatchSent: activeSwatch === "sent" ? true : prev.vendorProductInfo.swatchSent,
                        swatchReceived: activeSwatch === "received" ? true : prev.vendorProductInfo.swatchReceived,
                    },
                    swatchSent: activeSwatch === "sent" ? true : prev.swatchSent,
                    swatchReceived: activeSwatch === "received" ? true : prev.swatchReceived,
                }));

                notify({
                    error: false,
                    success: true,
                    title: successTitle,
                });
            }

            setActiveSwatch(null);
            navigate("/VendorHome", { state: { activeTab: 'Draft', tabinfo: 'Draft' } });
        } catch (error) {
            console.error("Error updating swatch:", error);

            notify({
                error: true,
                success: false,
                title: error?.message || "Something went wrong while updating swatch",
            });
        } finally {
            hideLoader();
        }
    };
    const handleSelectChangeFabric = (index, selectedValue) => {
        const newPairs = [...selectedPairsFabric];
        const oldKey = newPairs[index].key;
        const oldValue = parseInt(newPairs[index].value, 10) || 0;
        newPairs[index].key = selectedValue || '';
        newPairs[index].value = selectedValue ? newPairs[index].value : '';
        const newValue = parseInt(newPairs[index].value, 10) || 0;
        const updatedTotal = totalPercent - oldValue + newValue;
        setTotalpercent(updatedTotal);
        setSelectedPairsFabric(newPairs);
        setProduct(prevState => {
            const updatedComposition = { ...prevState.fabricContent.composition };
            if (oldKey && oldKey !== selectedValue) {
                delete updatedComposition[oldKey];
            }
            if (selectedValue) {
                updatedComposition[selectedValue] = newPairs[index].value || 0;
            }
            return {
                ...prevState,
                totalProductPercent: updatedTotal,
                fabricContent: {
                    ...prevState.fabricContent,
                    composition: updatedComposition,
                },
            };
        });
        const pairsObject = newPairs.reduce((acc, pair) => {
            if (pair.key && pair.value) {
                acc[pair.key] = pair.value;
            }
            return acc;
        }, {});

        if (Object.keys(pairsObject).length > 0) {
            fabricContentCode(pairsObject);
            setFCCValue(prev => {
                const existingValues = prev ? prev.split(' ') : [];
                const newValues = Object.entries(pairsObject).map(([key, value]) => {
                    const fcc = keyToNameMap[key]?.substring(0, 3).toUpperCase() || '';
                    return `${fcc}-${value}%`;
                });
                const updatedValues = [...new Set([...existingValues, ...newValues])].join(' ');
                return updatedValues;
            });
        } else {
            setFCCValue('');
            setProduct(prevState => ({
                ...prevState,
                fabricContent: {
                    ...prevState.fabricContent,
                    value: '',
                },
            }));
        }
        setInputError(prev => ({
            ...prev,
            fabricCompositionError: false,
            fabricContentError: false,
            fabricContentErrorMessage: '',
        }));
    };
    useEffect(() => {
        fetchFabricContent();
        setFCCValue(product?.fabricContent?.value);
        getFabricValues();
    }, []);
    const fetchFabricContent = async () => {
        try {
            const res = await B2B_API.get('product-category?status=ACTIVE').json();
            const categories = res.response;
            const category = categories.find(cat => cat.name === 'Fabric Content');
            setFabricContent(category);
            setSelectedPairsFromProductFabric();
        } catch (error) {
            console.error('Error fetching fabric content:', error);
        }
    };

    const setSelectedPairsFromProductFabric = () => {
        const { fabricContent } = product;
        const keys = Object.keys(fabricContent?.composition);
        if (_.size(keys) > 0) {
            setSelectedPairsFabric(_.map(keys, key => ({
                key,
                value: fabricContent?.composition[key],
            })));
        }
    };
    function findEmptyChildNodes(node) {
        const result = [];
        function traverse(node) {
            if (node && node.child && node.child.length === 0) {
                result.push(node);
            }
            if (node && node.child) {
                node.child.forEach(traverse);
            }
        }
        traverse(node);
        return result;
    }
    const keyToNameMap = lastChild.reduce((map, item) => {
        map[item.categoryId] = item.name;
        return map;
    }, {});
    useEffect(() => {
        if (fabricContent) {
            const emptyNodes = findEmptyChildNodes(fabricContent);
            setLastChild(emptyNodes);
        }
    }, [fabricContent]);
    const handleMultiSelectChangeFabric = (index, value) => {
        const newPairs = [...selectedPairsFabric];
        const key = newPairs[index].key;
        const previousValue = parseInt(newPairs[index].value, 10) || 0;
        const updatedTotal = totalPercent - previousValue + value;
        if (key) {
            newPairs[index].value = value;
            setSelectedPairsFabric(newPairs);
            setTotalpercent(updatedTotal);
            setProduct(prevState => ({
                ...prevState,
                totalProductPercent: updatedTotal,
                fabricContent: {
                    ...prevState.fabricContent,
                    composition: {
                        ...prevState.fabricContent.composition,
                        [key]: value,
                    },
                },
            }));
            const pairsObject = newPairs.reduce((acc, pair) => {
                if (pair.key && pair.value) {
                    acc[pair.key] = pair.value;
                }
                return acc;
            }, {});
            fabricContentCode(pairsObject);
        }
        setInputError(prev => ({
            ...prev,
            fabricCompositionError: false,
            fabricContentError: false,
            fabricContentErrorMessage: '',
        }));
    };


    const addNewPairFabric = () => {
        const totalSum = _.sumBy(selectedPairsFabric, (item) => parseInt(item.value));
        if (totalSum < 100) {
            setSelectedPairsFabric([...selectedPairsFabric, { key: '', value: '' }]);
            setInputError(prev => ({
                ...prev,
                fabricCompositionError: false,
                fabricContentError: false,
                fabricContentErrorMessage: '',
            }));
        }
    };
    const removePairFabric = (index, value) => {
        const newPairs = [...selectedPairsFabric];
        const removedKey = newPairs[index].key;
        const updatedTotal = totalPercent - value;
        setTotalpercent(updatedTotal);
        newPairs.splice(index, 1);
        setSelectedPairsFabric(newPairs);
        const pairsObject = newPairs.reduce((acc, pair) => {
            if (pair.key && pair.value) {
                acc[pair.key] = pair.value;
            }
            return acc;
        }, {});
        fabricContentCode(pairsObject);
        setProduct(prevState => {
            const { [removedKey]: _, ...newComposition } = prevState.fabricContent?.composition;
            return {
                ...prevState,
                totalProductPercent: updatedTotal,
                fabricContent: {
                    ...prevState.fabricContent,
                    composition: newComposition,
                    value: fCCValue,
                },
            };
        });
    };

    const ChangeHandlerFabric = (selectedValue) => {
        const selectedFabric = fabricValue.find(fabric => fabric.value === selectedValue);
        const compositionArray = Object.entries(selectedFabric?.composition);

        const pair = selectedFabric && selectedFabric.value
            ? selectedFabric.value.split(' ').reduce((acc, item) => {
                const [key, value] = item.split('-');
                acc.push(parseInt(value));
                return acc;
            }, [])
            : [];

        const valueOrderMap = pair.reduce((acc, value, index) => {
            acc[value] = index;
            return acc;
        }, {});

        const selectedPairs = compositionArray.sort((a, b) => {
            return valueOrderMap[a[1]] - valueOrderMap[b[1]];
        });
        setSelectedPairsFabric(selectedPairs.map(([key, value]) => ({ key, value })));
        const totalSum = selectedPairs.reduce((sum, [_, value]) => sum + parseInt(value, 10) || 0, 0);
        setTotalpercent(totalSum);
        const pairsObject = selectedPairs.reduce((acc, [key, value]) => {
            acc[key] = value;
            return acc;
        }, {});
        if (Object.keys(pairsObject).length > 0) {
            setProduct(prevState => ({
                ...prevState,
                totalProductPercent: totalSum,
                fabricContent: {
                    ...prevState.fabricContent,
                    composition: pairsObject,
                },
            }));
            fabricContentCode(pairsObject);
        } else {
            setFCCValue('');
            setSelectedPairsFabric([{ key: '', values: [], value: null }]);
            setProduct(prevState => ({
                ...prevState,
                totalProductPercent: 0,
                fabricContent: {
                    ...prevState.fabricContent,
                    composition: {},
                    value: '',
                },
            }));
        }
        setInputError(prev => ({
            ...prev,
            fabricCompositionError: false,
            fabricContentError: false,
            fabricContentErrorMessage: '',
        }));
    };
    const getFabricValues = async () => {
        try {
            const res = await B2B_API.get(`fabric?status=ACTIVE`).json();
            setFabricValue(res?.response);
        } catch (error) {
            console.error('Error fetching fabric values: ', error);
        }
    };

    useEffect(() => {
        fetchAllMappedRib();
    }, [debouncedSearchTerm, product?.mappedFabric])
    // useEffect(() => {
    //     setProduct((prev) => ({
    //         ...prev,
    //         vendorImages: imageFiles, // store as File[] directly
    //     }));
    // }, [imageFiles, setProduct]);

    const fetchAllBrand = async () => {
        try {
            const res = await B2B_API.get(`brand`).json();
            setBrand(res.response);
        } catch (err) {
            console.error("Failed to Fetch Brand");
        }
    };



    const fetchAllMappedRib = async () => {
        try {
            const res = await B2B_API.get(`product/fabricProduct/search?searchTerm=${debouncedSearchTerm}&productsId=${product?.mappedFabric || []}`).json();
            setMappedRib(res.response.content);
        } catch (err) {
            console.error("Failed to Fetch Brand");
        }
    };
    const [width, setWidth] = useState({
        inches: '',
        centimeter: '',
        meter: '',
        meter_per_kg: '',
    });
    const [uom, setUom] = useState({
        kg: '',
        meter_per_roll: '',
        yard_per_roll: '',
    });

    // multiple files in context state
    const fileChangee = (files) => {
        if (!files || files.length === 0) return;

        const validFiles = Array.from(files).filter((file) =>
            ["image/jpeg", "image/png"].includes(file.type)
        );

        if (validFiles.length === 0) {
            setImageError("Only PNG or JPEG files are allowed.");
            return;
        }

        setImageFile((prev) => [...(prev || []), ...validFiles]);
        setImageError(null);
    };

    const clearFilee = () => {
        setImageFile([]);
        resetRef.current?.();
    };

    const removeSingleFile = (index) => {
        setImageFile((prev) => prev.filter((_, i) => i !== index));
    };


    const handleWeightChange = (event) => {
        const newWeight = parseFloat(event.target.value) || 0;
        handleChange(event, 'metrics.weight', 'weightErrorMessage');

        const meterValue = width.meter;
        const newMeterPerKg = meterValue && newWeight ? (1000 / (meterValue * newWeight)).toFixed(2) : '';

        setWidth((prevWidth) => {
            const updatedWidth = {
                ...prevWidth,
                meter_per_kg: isNaN(newMeterPerKg) ? '' : newMeterPerKg,
            };
            return updatedWidth;
        });

        setProduct((prevState) => {
            const updatedMetrics = {
                ...prevState.metrics,
                weight: newWeight,
                meterPerKg: newMeterPerKg ? parseFloat(newMeterPerKg) : prevState.metrics.meterPerKg,
            };
            return {
                ...prevState,
                metrics: updatedMetrics,
            };
        });
    };


    const fetchAllTags = async () => {
        try {
            const res = await B2B_API.get(`product-tag`).json();
            setProductTags(res.response);
        } catch (err) {
            console.error("Failed to Fetch Brand");
        }
    };
    const clearFile = () => {
        if (resetRef.current) {
            resetRef.current();
        }
        setImageFile(null);
        setProduct(prev => ({
            ...prev,
            vendorImages: []
        }));
    };

    const fileChange = (file) => {
        const MAX_SIZE_BYTES = 3 * 1024 * 1024;

        if (file) {
            if (file.size > MAX_SIZE_BYTES) {
                setImageError('File size should be less than 3MB');
                setImageFile(null);
                setProduct(prev => ({
                    ...prev,
                    vendorImages: []
                }));
            } else {
                setImageError('');
                setImageFile(file);
                setProduct(prev => ({
                    ...prev,
                    vendorImages: URL.createObjectURL(file)
                }));
            }
        } else {
            setImageFile(null);
            setProduct(prev => ({
                ...prev,
                vendorImages: []
            }));
        }
    };


    const renderUOMText = () => {
        const { unitOfMeasures } = product.otherInformation || ''
        const json = [

            {
                label: "Meter",
                value: product.otherInformation.meter,
                onChange: (event) => handleChange(event, "meter"),
                type: "number",
                fieldType: 'textField',
                placeholder: "Enter Meter",
                visible: unitOfMeasures?.isMeter
            },
            {
                label: "Yard",
                value: convertMeterToYard(),
                onChange: (event) => handleChange(event, "yard"),
                type: "number",
                fieldType: 'textField',
                placeholder: "Enter Yard",
                visible: unitOfMeasures?.isYard
            },
        ];

        const inputFields = json.map((item, index) => {
            return item.visible && <B2BInput
                key={index}
                type={item.type}
                value={item.value}
                onChange={item.onChange}
                placeholder={item.placeholder}
                style={{
                    width: '5rem',
                    height: '30px',
                    marginBottom: '1rem',
                }}

            />
        }
        );

        return inputFields.length > 0 ? (
            <div style={{ display: 'flex', gap: '.5rem' }}>
                {inputFields}
            </div>
        ) : null;
    };


    const convertMeterToYard = () => {
        const res = product.otherInformation.meter * 1.09632;
        return res.toFixed(2);
    }

    const handleUOMChange = (value) => {
        if (value !== "Roll") {
            setSelectedUOM(value);
            handleChange(value, "UOM", "uomErrorMessage");
        }
    };

    const json = useMemo(() => [
        {
            label: 'Stock Type',
            value: product?.readyStock
                ? 'readyStock'
                : product?.vendorReadyStock
                    ? 'vendorReadyStock'
                    : product?.orderDriven
                        ? 'orderDriven'
                        : '',
            onChange: (e) => {
                const val = typeof e === 'string' ? e : e?.target?.value;
                setProduct((prev) => ({
                    ...prev,
                    readyStock: val === 'readyStock',
                    vendorReadyStock: val === 'vendorReadyStock',
                    orderDriven: val === 'orderDriven',
                    vendorProductInfo: {
                        ...prev.vendorProductInfo,
                        readyStock: val === 'readyStock',
                        vendorReadyStock: val === 'vendorReadyStock',
                        orderDriven: val === 'orderDriven',
                    }
                }));
                setInputError((prev) => ({
                    ...prev,
                    stockTypeError: false,
                    stockTypeErrorMessage: '',
                }));
            },
            type: "select",
            fieldType: 'selectField',
            require: true,
            placeholder: "Select Stock Type",
            options: [
                { label: "Ready Stock", value: "vendorReadyStock" },
                { label: "Made To Order", value: "orderDriven" }
            ],
            disabled: isReadOnly,
            error: inputError?.stockTypeErrorMessage || '',
        },
        {
            label: "Vendor Product Id",
            value: product.vendorProductCode,
            onChange: (event) => handleChange(event, "vendorProductCode", "vendorProductCodeErrorMessage"),
            type: "text",
            require: true,
            fieldType: 'textField',
            disabled: isReadOnly,
            placeholder: "Enter Product Id",
            error: inputError.vendorProductCodeErrorMessage
        },
        {
            label: "Vendor Product Name",
            value: product.vendorProductName,
            onChange: (event) => handleChange(event, "vendorProductName", "vendorProductNameErrorMessage"),
            type: "text",
            fieldType: 'textField',
            require: !product?.orderDriven,
            hidden: Boolean(product?.orderDriven),
            disabled: Boolean(product?.orderDriven) || isReadOnly,
            placeholder: "Enter Product Name",
            error: inputError.vendorProductNameErrorMessage
        },

        {
            label: "UOM",
            onChange: (value) => handleChange(value, "UOM", "uomErrorMessage"),
            type: "radio",
            fieldType: "radioField",
            options: [
                { label: "Kg", value: "isKg", },
                { label: "Meter", value: "isMeter" },
                { label: "Yard", value: "isYard" }
            ],
            name: "UOM",
            placeholder: "Select UOM Type",
            require: true,
            className: "form-group",
            disabled: isReadOnly,
            error: inputError?.uomErrorMessage,

            uomchecked: (option) => product?.otherInformation?.unitOfMeasures?.[option?.value] || false
        },
        {
            label: 'Weight (in gsm)',
            value: product?.metrics?.weight || '',
            onChange: (event) => handleChange(event, 'metrics.weight', 'gsmErrorMessage'),
            type: "number",
            fieldType: 'textField',
            require: true,
            placeholder: "Enter weight  ",
            disabled: isReadOnly && product?.metrics?.editWeight ? true : false,
            error: inputError?.gsmErrorMessage || '',
        },
        {
            label: 'Width',
            value: product?.metrics?.width || '',
            onChange: (event) => handleChange(event, 'width', 'widthErrorMessage'),
            type: "number",
            fieldType: 'widthField',
            disabled: isReadOnly,
            placeholder: "Enter Inches",
            require: true,
            error: inputError?.widthErrorMessage || '',
        },


    ], [mappedRib, product, inputError, isReadOnly])
    const json2 = useMemo(() => [

        {
            label: 'Price',
            value: product.vendorProductInfo?.costPrice || '',
            onChange: (event) => handleChange(event, 'priceSetting.costPrice', 'costPriceErrorMessage'),
            type: "number",
            fieldType: 'textField',
            require: false,
            disabled: isReadOnly,
            placeholder: "Enter Price  ",
            error: inputError?.costPriceErrorMessage || '',
        },
        {
            label: 'Commission Amt',
            value: product.vendorProductInfo?.commission || '',
            onChange: (event) => handleChange(event, 'vendorProductInfo.commission', 'commissionErrorMessage'),
            type: "number",
            fieldType: 'textField',
            disabled: isReadOnly || product?.vendorProductInfo?.commissionPercentage > 0,
            placeholder: "Enter Commission  ",
            error: inputError?.commission || '',
        },
        {
            label: 'Commission %',
            value: product.vendorProductInfo?.commissionPercentage || '',
            onChange: (event) => handleChange(event, 'vendorProductInfo.commissionPercentage', 'commissionPercentageErrorMessage'),
            type: "number",
            fieldType: 'textField',
            disabled: isReadOnly || product?.vendorProductInfo?.commission > 0,
            placeholder: "Enter Commission Percentage  ",
            error: inputError?.commissionPercentage || '',
        },

        {
            fieldType: "checkbox",
            label: "Price is Gross of cone weight",
            value: product?.vendorProductInfo?.priceInclConeWeight === true,
            onChange: () =>
                setProduct((prev) => {
                    const isNowGross = prev.vendorProductInfo?.priceInclConeWeight === true ? null : true;
                    return {
                        ...prev,
                        otherInformation: {
                            ...prev.otherInformation,
                            coneWeight: isNowGross === true ? prev.otherInformation?.coneWeight : '',
                        },
                        vendorProductInfo: {
                            ...prev.vendorProductInfo,
                            priceInclConeWeight: isNowGross,
                            coneWeight: isNowGross === true ? prev.vendorProductInfo?.coneWeight : '',
                        },
                    };
                }),
            type: "checkbox",
            disabled: isReadOnly,
        },
        {
            fieldType: "checkbox",
            label: "Price is Net of cone weight",
            value: product?.vendorProductInfo?.priceInclConeWeight === false,
            onChange: () =>
                setProduct((prev) => {
                    const isNowNet = prev.vendorProductInfo?.priceInclConeWeight === false ? null : false;
                    return {
                        ...prev,
                        otherInformation: {
                            ...prev.otherInformation,
                            coneWeight: isNowNet === true ? prev.otherInformation?.coneWeight : '',
                        },
                        vendorProductInfo: {
                            ...prev.vendorProductInfo,
                            priceInclConeWeight: isNowNet,
                            coneWeight: isNowNet === true ? prev.vendorProductInfo?.coneWeight : '',
                        },
                    };
                }),
            type: "checkbox",
            disabled: isReadOnly,
        },
        {
            label: 'Std. kg',
            value: product.vendorProductInfo?.standardRollWt || product?.standardRollWt || '',
            onChange: (event) => {
                const val = event.target.value;
                setProduct((prev) => ({
                    ...prev,
                    standardRollWt: val,
                    vendorProductInfo: {
                        ...prev.vendorProductInfo,
                        standardRollWt: val,
                    }
                }));
            },
            type: "number",
            fieldType: 'textField',
            disabled: isReadOnly,
            placeholder: "Enter Std. kg",
            require: false,
        },
        {
            label: 'Cone weight (grms)',
            value: product.vendorProductInfo?.coneWeight || product?.otherInformation?.coneWeight || '',
            onChange: (event) => {
                const val = event.target.value;
                setProduct((prev) => ({
                    ...prev,
                    vendorProductInfo: {
                        ...prev.vendorProductInfo,
                        coneWeight: val,
                    },
                    otherInformation: {
                        ...prev.otherInformation,
                        coneWeight: val
                    }
                }))
            },
            type: "number",
            fieldType: 'textField',
            require: product?.vendorProductInfo?.priceInclConeWeight === true ? true : false,
            disabled: isReadOnly || product?.vendorProductInfo?.priceInclConeWeight !== true,
            placeholder: "Enter cone weight  ",
            error: product?.vendorProductInfo?.priceInclConeWeight === true ? (inputError?.coneWeightErrorMessage || '') : '',
        },
        {
            label: 'MOQ',
            value: product?.moq || product?.vendorProductInfo?.moq || '',
            onChange: (event) => {
                const val = event.target.value;
                setProduct((prev) => ({
                    ...prev,
                    moq: val,
                    vendorProductInfo: {
                        ...prev.vendorProductInfo,
                        moq: val,
                    }
                }));
            },
            type: "text",
            fieldType: 'textField',
            disabled: isReadOnly,
            placeholder: "Enter MOQ",
            require: false,
        },
        {
            label: 'MCQ',
            value: product?.mcq || product?.vendorProductInfo?.mcq || '',
            onChange: (event) => {
                const val = event.target.value;
                setProduct((prev) => ({
                    ...prev,
                    mcq: val,
                    vendorProductInfo: {
                        ...prev.vendorProductInfo,
                        mcq: val,
                    }
                }));
            },
            type: "text",
            fieldType: 'textField',
            disabled: isReadOnly,
            placeholder: "Enter MCQ",
            require: false,
        },
    ], [mappedRib, product, inputError, isReadOnly])


    const handleSelectChange = (value) => {
        const group = _.find(groups, gr => gr.name === value);
        setCategoryTree(prevTree => [{ ...prevTree[0], productGroup: group }]);
    };

    const getAllTaxonomy = async () => {
        const res = await B2B_API.get("taxonomy").json();
        setTaxonomy(res.response);
    }

    const handleOpenModal = (key) => {
        setActiveComponent(key)
        setModalContent(prev => ({ ...prev, title: key }))
        if (key.toLowerCase() === 'season') {
            setOpenSeason(true);
        } else {
            setOpenSeason(false)
        }
        setOpen(true);
    }

    const handleModalChange = (event, key) => {
        setModalContent((prev => ({ ...prev, [key]: event?.target?.value ? event?.target?.value : event })))
    }

    const saveData = async (e, key) => {
        e.preventDefault();
        try {
            await B2B_API.post(`${key?.toLowerCase()}`, { json: modalContent }).json();
            setOpen(false);
            setContentUpdated(prev => !prev)
            setModalContent(initialData)
            notify({
                title: 'Success!',
                message: `${modalContent.title}` + ' added Successfully.',
                error: false,
                success: true,
            });
        } catch (e) {
            notify({
                error: true,
                success: false,
                title: e?.message
            });
        }
    }

    const handleClose = () => {
        setOpen(false)
        setOpenSeason(false)
    }



    const getAllSeason = async () => {
        try {
            const res = await B2B_API.get(`season`).json();
            setSeason(res.response);
        }
        catch (e) {
            console.log("Fail to Fetch Season", e);

        }
    }

    const allImages = imageFile?.length > 0 ? imageFile : product?.vendorImages1 || [];


    return (
        <>
            <Modal
                opened={!!activeSwatch}
                title={
                    activeSwatch === "sent"
                        ? "Confirm Swatch Sent"
                        : "Confirm Swatch Received"
                }
                onClose={() => {
                    setActiveSwatch(null);
                    setSwatchNotifyData({
                        awbNumber: '',
                        docNumber: '',
                        courierName: '',
                        swatchQuantity: '',
                        dispatchDate: '',
                        deliveryDate: '',
                    });
                }}>
                <div>
                    {activeSwatch === "sent" && (
                        <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginBottom: "20px" }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>AWB Number <span style={{ color: "red" }}>*</span></label>
                                <B2BInput
                                    type="text"
                                    placeholder="Enter AWB Number"
                                    value={swatchNotifyData.awbNumber}
                                    required
                                    onChange={(e) =>
                                        setSwatchNotifyData((prev) => ({
                                            ...prev,
                                            awbNumber: e.target.value,
                                        }))
                                    }
                                />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Doc Number <span style={{ color: "red" }}>*</span></label>
                                <B2BInput
                                    type="text"
                                    placeholder="Enter Doc Number"
                                    value={swatchNotifyData.docNumber}
                                    required
                                    onChange={(e) =>
                                        setSwatchNotifyData((prev) => ({
                                            ...prev,
                                            docNumber: e.target.value,
                                        }))
                                    }
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Courier Name <span style={{ color: "red" }}>*</span></label>
                                <B2BInput
                                    type="text"
                                    placeholder="Enter Courier Name"
                                    value={swatchNotifyData.courierName}
                                    required
                                    onChange={(e) =>
                                        setSwatchNotifyData((prev) => ({
                                            ...prev,
                                            courierName: e.target.value,
                                        }))
                                    }
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Swatch Qty <span style={{ color: "red" }}>*</span></label>
                                <B2BInput
                                    type="text"
                                    placeholder="Enter Swatch Qty"
                                    value={swatchNotifyData.swatchQuantity}
                                    required
                                    onChange={(e) =>
                                        setSwatchNotifyData((prev) => ({
                                            ...prev,
                                            swatchQuantity: e.target.value,
                                        }))
                                    }
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Dispatch Date <span style={{ color: "red" }}>*</span></label>
                                <B2BInput
                                    type="date"
                                    value={swatchNotifyData.dispatchDate}
                                    required
                                    onChange={(e) =>
                                        setSwatchNotifyData((prev) => ({
                                            ...prev,
                                            dispatchDate: e.target.value,
                                        }))
                                    }
                                />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                <label style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>Delivery Date <span style={{ color: "red" }}>*</span></label>
                                <B2BInput
                                    type="date"
                                    value={swatchNotifyData.deliveryDate}
                                    required
                                    onChange={(e) =>
                                        setSwatchNotifyData((prev) => ({
                                            ...prev,
                                            deliveryDate: e.target.value,
                                        }))
                                    }
                                />
                            </div>
                        </div>
                    )}
                    <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                        <Button
                            onClick={() => setActiveSwatch(null)}
                            style={{ backgroundColor: "red" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleSwatchSample}
                            style={{ backgroundColor: "#8BC53F" }}
                        >
                            Confirm
                        </Button>
                    </div>
                </div>
            </Modal>

            <div className='productType-container' style={{ display: 'flex', flexDirection: 'column', padding: "0rem 2rem" }}>
                {/* ── Section 1: 4-column top row (Vendor Id | Vendor Name | UOM | Weight) ── */}
                <form>
                    <div className="pt-form-row-4">
                        {json.filter(field => !field.hidden).map((field, index) => (
                            <div key={index} className="pt-field-4">
                                <div className="pt-label">
                                    {field.label}
                                    {field.require && <span className="required-star">*</span>}
                                </div>
                                <div className="pt-input-wrap">
                                    {field.fieldType === 'textField' && (
                                        <B2BInput
                                            value={field.value}
                                            className="input-textField"
                                            style={field.style}
                                            disabled={field.disabled}
                                            onChange={field.onChange}
                                            type={field.type}
                                            placeholder={field.placeholder}
                                            error={field.error}
                                        />
                                    )}
                                    {field.fieldType === 'widthField' && (
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <span style={{ fontSize: '13px', fontWeight: '500', whiteSpace: 'nowrap', color: '#555' }}>Inches:</span>
                                                    <B2BInput
                                                        value={field.value}
                                                        className="input-textField"
                                                        disabled={field.disabled}
                                                        onChange={field.onChange}
                                                        type="number"
                                                        placeholder="Enter Inches"
                                                    />
                                                </div>
                                                <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <span style={{ fontSize: '13px', fontWeight: '500', whiteSpace: 'nowrap', color: '#555' }}>Cms:</span>
                                                    <B2BInput
                                                        value={field.value ? (field.value * 2.54).toFixed(2) : ''}
                                                        className="input-textField"
                                                        disabled={true}
                                                        placeholder="Cm Auto calculated"
                                                    />
                                                </div>
                                            </div>
                                            {field.error && (
                                                <span className="error-message" style={{ color: 'red', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                                                    {field.error}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                    {field.fieldType === 'selectField' && (
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <B2BSelect
                                                value={field.value}
                                                data={field.options}
                                                disabled={field.disabled}
                                                onChange={field.onChange}
                                                placeholder={field.placeholder}
                                                clearable
                                                error={field.error}
                                            />
                                        </div>
                                    )}
                                    {field.fieldType === 'radioField' && (
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <div className="radio-group">
                                                {field.options.map((option, idx) => (
                                                    <div key={idx} className="radio-item">
                                                        <input
                                                            type="radio"
                                                            value={option.value}
                                                            name={field.name}
                                                            onChange={field.onChange}
                                                            disabled={field.disabled}
                                                            checked={
                                                                field.uomchecked
                                                                    ? field.uomchecked(option)
                                                                    : field.checked === option.value
                                                            }
                                                        />
                                                        <label className="radio-label">{option.label}</label>
                                                    </div>
                                                ))}
                                            </div>
                                            {field.error && (
                                                <span className="error-message" style={{ color: 'red', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                                                    {field.error}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </form>

                <section className="fabric-content-section">
                    <h2>Fabric Content</h2>
                    <div className="fabric-content-inner-top-pt">
                        <div>
                            <label className="fabric-label">Fabric Content Code</label>
                            <B2BInput className="input-textField" value={fCCValue} type="text" disabled={true} clearable={fCCValue ? "×" : false} />
                        </div>
                        <div>
                            <label className="fabric-label">Combination</label>
                            <B2BSelect
                                value={product?.fabricValue}
                                data={[...new Set((fabricValue || []).map(v => v?.value))].filter(Boolean)}
                                onChange={(e) => ChangeHandlerFabric(e)}
                                clearable={true}
                                disabled={(!!product?.draftProductId) && product.editFabricContent}
                                placeholder="Select FCC Combination"
                                className="input-textField"
                            />
                        </div>
                    </div>
                    <div className="fabric-content-inner-bottom">
                        <div className="fabric-content-g-row">
                            <div className="fabric-content-g-col fabric-content-g-s-6 fabric-content-g-m-4">
                                <label>
                                    <span className="fabric-content-text-label">Fabric</span>
                                    <span className="error-message"> *</span>
                                </label>
                            </div>
                            <div className="fabric-content-g-col fabric-content-g-s-6 fabric-content-g-m-8">
                                <label>
                                    <span className="fabric-content-text-label">Composition(%)</span>
                                    <span className="error-message"> *</span>
                                </label>
                            </div>
                        </div>
                        {selectedPairsFabric.map((pair, index) => (
                            <div key={index} className="fabric-content-g-row">
                                <div className="fabric-content-g-col fabric-content-g-s-6 fabric-content-g-m-4">
                                    <B2BSelect
                                        value={selectedPairsFabric[index]?.key || ''}
                                        data={getAvailableKeysFabric(index).map(key => ({ value: key, label: keyToNameMap[key] }))}
                                        clearable={true}
                                        disabled={(!!product?.draftProductId) && product.editFabricContent}
                                        className="input-textField"
                                        onChange={(e) => handleSelectChangeFabric(index, e)}
                                        error={inputError?.fabricContentError ? inputError?.fabricContentError : null}
                                    />
                                </div>
                                <div className="fabric-content-g-col fabric-content-g-s-6 fabric-content-g-m-8 fabric-content-mb2" style={{ display: 'flex' }}>
                                    <NumberInput
                                        value={pair.value || 0}
                                        required={true}
                                        disabled={!pair.key || (!!product?.draftProductId) && product.editFabricContent}
                                        clearable={true}
                                        className="input-textField"
                                        max={100}
                                        styles={{ input: { fontSize: '14px' } }}
                                        onChange={(e) => handleMultiSelectChangeFabric(index, e)}
                                        rightSection={<IconPercentage size={20} />}
                                        error={inputError?.fabricContentErrorMessage}
                                    />
                                    {index > 0 && (
                                        <button
                                            type="button"
                                            className="fabric-content-btn fabric-content-btn--icon-no fabric-content-ml2"
                                            style={{ marginLeft: '10px' }}
                                            disabled={(!!product?.draftProductId) && product.editFabricContent}
                                            onClick={() => removePairFabric(index, pair.value)}
                                        >
                                            <FontAwesomeIcon className="fa fabric-content-icon" icon={faTrash} />
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                        <div className="fabric-content-g-row">
                            {totalPercent < 100 && (
                                <div className="fabric-content-g-col fabric-content-g-s-6 fabric-content-g-m-4">
                                    <button
                                        type="button"
                                        className="fabric-content-btn fabric-content-btn--text-go"
                                        onClick={addNewPairFabric}
                                    >
                                        <FontAwesomeIcon className="fa fabric-content-icon fabric-content-mr2" icon={faPlus} />
                                        Add another attribute
                                    </button>
                                </div>
                            )}
                        </div>
                        <div>
                            <p className="fabric-label">Overall Composition Percentage is: {totalPercent}</p>
                            {inputError?.fabricCompositionError && (
                                <p className="error-message">{inputError.fabricCompositionErrorMessage}</p>
                            )}
                        </div>

                        {(product?.vendorReadyStock || product?.vendorProductInfo?.vendorReadyStock || (!product?.orderDriven && !product?.vendorProductInfo?.orderDriven)) && selectedPairsFabric?.filter(p => p.key).length > 0 && (
                            <div style={{ marginTop: '1.25rem', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '16px', backgroundColor: '#f8fafc' }}>
                                <h4 style={{ margin: '0 0 12px 0', fontSize: '15px', fontWeight: 'bold', color: '#1e293b' }}>
                                    Fiber Details (Wrap & Wefp) <span className="required-star">*</span>
                                </h4>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#f1f5f9', textAlign: 'left', color: '#475569' }}>
                                            <th style={{ padding: '10px 12px', borderBottom: '2px solid #cbd5e1' }}>Fabric Chosen</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '2px solid #cbd5e1', width: '35%' }}>Wrap</th>
                                            <th style={{ padding: '10px 12px', borderBottom: '2px solid #cbd5e1', width: '35%' }}>Wefp</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedPairsFabric.filter(p => p.key).map((pair, idx) => {
                                            const fabricName = keyToNameMap[pair.key] || pair.key;
                                            const label = pair.value ? `${fabricName} ${pair.value}%` : fabricName;
                                            let warpWeftMap = {};
                                            try {
                                                const rawVal = product?.warpWeftDetails || product?.vendorProductInfo?.warpWeftDetails;
                                                warpWeftMap = typeof rawVal === 'string'
                                                    ? JSON.parse(rawVal || '{}')
                                                    : (rawVal || {});
                                            } catch (e) {
                                                warpWeftMap = {};
                                            }
                                            const currentWarp = warpWeftMap[pair.key]?.warp || warpWeftMap[fabricName]?.warp || '';
                                            const currentWeft = warpWeftMap[pair.key]?.weft || warpWeftMap[pair.key]?.wefp || warpWeftMap[fabricName]?.weft || warpWeftMap[fabricName]?.wefp || '';

                                            return (
                                                <tr key={idx} style={{ borderBottom: '1px solid #e2e8f0' }}>
                                                    <td style={{ padding: '10px 12px', fontWeight: '600', color: '#334155' }}>
                                                        {label}
                                                    </td>
                                                    <td style={{ padding: '8px 12px' }}>
                                                        <B2BInput
                                                            placeholder="Enter Wrap"
                                                            value={currentWarp}
                                                            disabled={(!!product?.draftProductId) && product.editFabricContent}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                const existingItem = warpWeftMap[pair.key] || warpWeftMap[fabricName] || {};
                                                                const itemObj = {
                                                                    ...existingItem,
                                                                    warp: val,
                                                                    fabricName: fabricName
                                                                };
                                                                const updatedDetails = {
                                                                    ...warpWeftMap,
                                                                    [pair.key]: itemObj,
                                                                    ...(fabricName ? { [fabricName]: itemObj } : {})
                                                                };
                                                                const jsonStr = JSON.stringify(updatedDetails);
                                                                setProduct((prev) => ({
                                                                    ...prev,
                                                                    warpWeftDetails: jsonStr,
                                                                    vendorProductInfo: {
                                                                        ...prev.vendorProductInfo,
                                                                        warpWeftDetails: jsonStr
                                                                    }
                                                                }));
                                                            }}
                                                            className="input-textField"
                                                        />
                                                    </td>
                                                    <td style={{ padding: '8px 12px' }}>
                                                        <B2BInput
                                                            placeholder="Enter Wefp"
                                                            value={currentWeft}
                                                            disabled={(!!product?.draftProductId) && product.editFabricContent}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                const existingItem = warpWeftMap[pair.key] || warpWeftMap[fabricName] || {};
                                                                const itemObj = {
                                                                    ...existingItem,
                                                                    weft: val,
                                                                    wefp: val,
                                                                    fabricName: fabricName
                                                                };
                                                                const updatedDetails = {
                                                                    ...warpWeftMap,
                                                                    [pair.key]: itemObj,
                                                                    ...(fabricName ? { [fabricName]: itemObj } : {})
                                                                };
                                                                const jsonStr = JSON.stringify(updatedDetails);
                                                                setProduct((prev) => ({
                                                                    ...prev,
                                                                    warpWeftDetails: jsonStr,
                                                                    vendorProductInfo: {
                                                                        ...prev.vendorProductInfo,
                                                                        warpWeftDetails: jsonStr
                                                                    }
                                                                }));
                                                            }}
                                                            className="input-textField"
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                                {inputError?.warpWeftError && (
                                    <p className="error-message" style={{ color: 'red', fontSize: '12px', marginTop: '8px', marginBottom: 0 }}>
                                        {inputError.warpWeftErrorMessage}
                                    </p>
                                )}
                            </div>
                        )}
                    </div>
                </section>

                {/* ── Section 2: Price / Cone weight / Commission ── */}
                <form style={{ marginTop: '1rem' }}>
                    {(() => {
                        const get = (label) => json2.find(f => f.label === label) || {};
                        const price = get('Price');
                        const gross = get('Price is Gross of cone weight');
                        const net = get('Price is Net of cone weight');
                        const cone = get('Cone weight (grms)');
                        const stdKg = get('Std. kg');
                        const commission = get('Commission Amt');
                        const commissionPct = get('Commission %');
                        const moq = get('MOQ');
                        const mcq = get('MCQ');

                        const isOrderDriven = product?.orderDriven === true;

                        return (
                            <div className="pt-section2-wrap">

                                {/* Row 1: Gross checkbox | Net checkbox */}
                                {!isOrderDriven && (
                                    <div className="pt-checkbox-2col">
                                        <label className={`pt-cone-option${gross.disabled ? ' is-disabled' : ''}`}>
                                            <Checkbox
                                                checked={gross.value}
                                                onChange={gross.onChange}
                                                disabled={gross.disabled}
                                                color="#8BC53F"
                                            />
                                            <span>{gross.label}</span>
                                        </label>
                                        <label className={`pt-cone-option${net.disabled ? ' is-disabled' : ''}`}>
                                            <Checkbox
                                                checked={net.value}
                                                onChange={net.onChange}
                                                disabled={net.disabled}
                                                color="#8BC53F"
                                            />
                                            <span>{net.label}</span>
                                        </label>
                                    </div>
                                )}

                                {/* Row 2: Price | Std. kg | Cone weight | Commission Amt | Commission % | MOQ | MCQ */}
                                <div className="pt-6col-grid">
                                    <div className="pt-field-col">
                                        <div className="pt-label">
                                            {price.label}
                                            {price.require && <span className="required-star"> *</span>}
                                        </div>
                                        <div className="pt-input-wrap">
                                            <B2BInput
                                                value={price.value}
                                                className="input-textField"
                                                disabled={price.disabled}
                                                onChange={price.onChange}
                                                type={price.type}
                                                placeholder={price.placeholder}
                                                error={price.error}
                                            />
                                        </div>
                                    </div>
                                    {!isOrderDriven && (
                                        <div className="pt-field-col">
                                            <div className="pt-label">
                                                {stdKg.label}
                                                {stdKg.require && <span className="required-star"> *</span>}
                                            </div>
                                            <div className="pt-input-wrap">
                                                <B2BInput
                                                    value={stdKg.value}
                                                    className="input-textField"
                                                    disabled={stdKg.disabled}
                                                    onChange={stdKg.onChange}
                                                    type={stdKg.type}
                                                    placeholder={stdKg.placeholder}
                                                    error={stdKg.error}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {!isOrderDriven && (
                                        <div className="pt-field-col">
                                            <div className="pt-label">
                                                {cone.label}
                                                {cone.require && <span className="required-star"> *</span>}
                                            </div>
                                            <div className="pt-input-wrap">
                                                <B2BInput
                                                    value={cone.value}
                                                    className="input-textField"
                                                    disabled={cone.disabled}
                                                    onChange={cone.onChange}
                                                    type={cone.type}
                                                    placeholder={cone.placeholder}
                                                    error={cone.error}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="pt-field-col">
                                        <div className="pt-label">
                                            {commission.label}
                                            {commission.require && <span className="required-star"> *</span>}
                                        </div>
                                        <div className="pt-input-wrap">
                                            <B2BInput
                                                value={commission.value}
                                                className="input-textField"
                                                disabled={commission.disabled}
                                                onChange={commission.onChange}
                                                type={commission.type}
                                                placeholder={commission.placeholder}
                                                error={commission.error}
                                            />
                                        </div>
                                    </div>
                                    <div className="pt-field-col">
                                        <div className="pt-label">
                                            {commissionPct.label}
                                            {commissionPct.require && <span className="required-star"> *</span>}
                                        </div>
                                        <div className="pt-input-wrap">
                                            <B2BInput
                                                value={commissionPct.value}
                                                className="input-textField"
                                                disabled={commissionPct.disabled}
                                                onChange={commissionPct.onChange}
                                                type={commissionPct.type}
                                                placeholder={commissionPct.placeholder}
                                                error={commissionPct.error}
                                            />
                                        </div>
                                    </div>
                                    <div className="pt-field-col">
                                        <div className="pt-label">
                                            {moq.label}
                                        </div>
                                        <div className="pt-input-wrap">
                                            <B2BInput
                                                value={moq.value}
                                                className="input-textField"
                                                disabled={moq.disabled}
                                                onChange={moq.onChange}
                                                type={moq.type}
                                                placeholder={moq.placeholder}
                                            />
                                        </div>
                                    </div>
                                    <div className="pt-field-col">
                                        <div className="pt-label">
                                            {mcq.label}
                                        </div>
                                        <div className="pt-input-wrap">
                                            <B2BInput
                                                value={mcq.value}
                                                className="input-textField"
                                                disabled={mcq.disabled}
                                                onChange={mcq.onChange}
                                                type={mcq.type}
                                                placeholder={mcq.placeholder}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        );
                    })()}
                </form>

            </div>
            <div className='productType-container' style={{ display: 'flex', flexDirection: 'column', padding: "0rem 2rem" }}>
                {/* Single-row form (horizontally scrollable on small screens) */}
                {/* <div className="pv-form-row" role="form" aria-label="product-variant-form-row" style={{ padding: "1rem" }}>
                    {jsonswatch?.map((field, idx) => (
                        <div key={idx} className="pv-field-card">
                            <label className="pv-label">
                                {field.label}
                                {field.require && <span className="pv-required"> </span>}
                            </label>

                            {field.fieldType === 'textField' && (
                                <B2BInput
                                    value={field.value}
                                    className='input-textField pv-input'
                                    style={field.style}
                                    disabled={field.disabled}
                                    onChange={field.onChange}
                                    type={field.type}
                                    placeholder={field.placeholder}
                                    error={field.error}
                                />
                            )}

                            {field.fieldType === 'checkbox' && (
                                <Checkbox
                                    checked={field.value}
                                    onChange={field.onChange}
                                    disabled={field.disabled}
                                    color='#8BC53F'

                                />
                            )}

                            {field.fieldType === "selectField" && (
                                <div className="pv-select-wrap">
                                    <B2BSelect
                                        data={field.data || []}
                                        value={field.value || ""}
                                        onChange={field.onChange}
                                        placeholder={field.placeholder}
                                        clearable={field.clearable}
                                        error={field.error}
                                        maxDropdownHeight={400}
                                        className='input-textField pv-input'
                                    />
                                </div>
                            )}

                            {field.fieldType === 'multiselectField' && (
                                <div className="pv-select-wrap">
                                    <MultiSelect
                                        value={product?.tags || []}
                                        placeholder="Tags"
                                        styles={{
                                            input: { padding: '10px', width: '100%' },
                                        }}
                                        size='xs'
                                        data={productTags.map(tag => tag.name) || []}
                                        onChange={(selectedTags) => handleChange({ target: { value: selectedTags } }, "tags")}
                                    />
                                </div>
                            )}

                            {field.fieldType === 'textAreaField' && (
                                <textarea
                                    value={field.value}
                                    className='form-input-textarea'
                                    disabled={field.disabled}
                                    onChange={field.onChange}
                                    placeholder={field.placeholder}
                                />
                            )}

                            {field.error && <div className="field-error">{field.error}</div>}
                        </div>
                    ))}
                </div> */}
            </div>
            <div className="pv-images-wrap" style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="pv-images-left">
                    {/* fixed-size box that always shows (placeholder when empty; carousel when images exist) */}
                    <div
                        className={`pv-carousel-box ${allImages.length === 0 ? 'pv-empty' : 'pv-has-images'}`}
                        aria-live="polite"
                    >
                        {allImages.length === 0 ? (
                            <div className="pv-empty-placeholder" role="status" aria-label="No images uploaded">
                                <IconUpload size={20} />
                                <div className="pv-empty-text">No images</div>
                            </div>
                        ) : (
                            <Carousel
                                withIndicators
                                height={180}
                                slideSize="100%"
                                align="start"
                                withControls={allImages.length > 1}
                                loop
                                styles={{
                                    indicator: {
                                        width: 8,
                                        height: 8,
                                        backgroundColor: '#888',
                                    },
                                }}
                            >
                                {allImages.map((file, index) => (
                                    <Carousel.Slide key={index} className="pv-carousel-slide">
                                        <div className="pv-carousel-inner">
                                            <img
                                                src={typeof file === 'string' ? file : URL.createObjectURL(file)}
                                                alt={`Uploaded-${index}`}
                                            />
                                            <Button
                                                size="xs"
                                                color="red"
                                                disabled={product?.draftProductId}
                                                className="pv-remove-btn"
                                                onClick={() => removeSingleFile(index)}
                                            >
                                                ✕
                                            </Button>
                                        </div>
                                    </Carousel.Slide>
                                ))}
                            </Carousel>
                        )}
                    </div>

                    {/* Buttons stay below the fixed box; FileButton opens file dialog */}
                    <Group className="pv-btn-row">
                        <FileButton
                            resetRef={resetRef}
                            onChange={fileChangee}
                            accept="image/png,image/jpeg"
                            multiple
                        >
                            {(props) => (
                                <Button
                                    {...props}
                                    style={{ backgroundColor: "#8BC53F", color: "white" }}
                                    disabled={product.draftProductId ? true : false}
                                >
                                    Add Images
                                </Button>
                            )}
                        </FileButton>

                        <Button
                            disabled={!imageFile || imageFile.length === 0 || product.draftProductId}
                            color="red"
                            onClick={clearFilee}
                        >
                            Reset All
                        </Button>
                    </Group>
                    {inputError?.imageError && (
                        <div style={{ color: "red", marginTop: "8px", fontWeight: "bold" }}>
                            {inputError?.imageErrorMessage || "Please upload Image!"}
                        </div>
                    )}
                </div>
                {imageError && (
                    <div style={{ color: "red", marginTop: "8px", fontWeight: "bold" }}>
                        {imageError}
                    </div>
                )}
            </div>

        </>
    );
};

export default ProductType;